import './app.scss';

import React, {Suspense} from 'react';
import AuthContextProvider from './auth/AuthContextProvider';
import {RootLayout} from './rootLayout';

export const App = (): React.JSX.Element => {
    return (
        <Suspense>
            <AuthContextProvider>
                <RootLayout></RootLayout>
            </AuthContextProvider>
        </Suspense>
    );
};

export default App;
